import { mapActions } from 'vuex';
import Events from '_utils/events';
import MagazineService from '_services/rest/modules/magazine';

export default {
  name: 'magazine-delete',
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteRow() {
      this.setToggle({ type: 'progress', bool: true });
      MagazineService.deleteMagazine(this.selectMagazine)
        .then(() => {
          this.close();
          Events.$emit('update:pagination', { page: 1 });
          this.activeAlert({ message: 'Revista deletada com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
};
